const PENDING_STATUS = 0
const IN_PROGRESS_STATUS_STATUS = 1
const OVERDUE_STATUS = 2
const FINALIZED_STATUS = 3

const PENDING_STATUS_LABEL = 'pending'
const IN_PROGRESS_STATUS_LABEL = 'in_progress'
const OVERDUE_STATUS_LABEL = 'overdue'
const FINALIZED_STATUS_LABEL = 'finalized'

const STATUSES = {
  [PENDING_STATUS_LABEL]: 'Pendente',
  [IN_PROGRESS_STATUS_LABEL]: 'Em Andamento',
  [OVERDUE_STATUS_LABEL]: 'Atrasado',
  [FINALIZED_STATUS_LABEL]: 'Finalizado',
}

export default {
  FINALIZED_STATUS_LABEL,
  FINALIZED_STATUS,
  IN_PROGRESS_STATUS_LABEL,
  IN_PROGRESS_STATUS_STATUS,
  OVERDUE_STATUS_LABEL,
  OVERDUE_STATUS,
  PENDING_STATUS_LABEL,
  PENDING_STATUS,
  STATUSES,
}
